export class DeleteSubscriberModel {
    public subscriberId : string;
}